import React, { useEffect, useState } from "react";
import "./Vip.css";
import VipHeader from "./VipHeader/VipHeader";
import VipStats from "./VipStats/VipStats";
import VipCard from "./VipCard/VipCard";
import VipBenefits from "./VipBenefits/VipBenefits";
import VipTabs from "./VipTabs/VipTabs";
import VipMyBenefits from "./VipMyBenefits/VipMyBenefits";
import Data_Loader from "../Common/Common_Component/Data_Loader/Data_Loader";
import { useDispatch, useSelector } from "react-redux";
import { GETVipLevel } from "../../features/auth/Slice";

function Vip() {
  // Loader js start
  const [loading, setLoading] = useState(false);

  const handleClick = () => {
    setLoading(true);

    setTimeout(() => {
      setLoading(false);
    }, 10000);
  };

  // Loader js end
  const dispatch = useDispatch()
  const Vip = useSelector((state) => state.auth.VipData);

  useEffect(() => { dispatch(GETVipLevel()) }, [dispatch]);

  const [viewingLevel, setViewingLevel] = useState(Vip?.level_id);
  console.log({ viewingLevel });
  console.log({ Level: Vip?.level_id });

  return (
    <div className="vip_page">
      <VipHeader Vip={Vip} />
      <div className="container">
        <VipStats Vip={Vip} />
        <VipCard
          userVipLevel={Vip?.level_id}
          currentExp={0}
          requiredExp={200000}
          onLevelChange={(level) => setViewingLevel(level)}
        />
        <VipBenefits activeLevel={viewingLevel} />
        <VipMyBenefits />
        <VipTabs />
        {/* Loader start*/}
        {/* {loading && <Data_Loader />}

        <button onClick={handleClick}>Show Loader</button> */}
        {/* Loader end*/}
      </div>
    </div>
  );
}

export default Vip;
